const API_BASE = import.meta.env.VITE_API_URL;

const handleResponse = async (response: Response) => {
  if (response.status === 401) {
    window.dispatchEvent(new Event('auth:unauthorized'));
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'API Request Failed');
  }
  return response.json();
};

export const billingService = {
  async initHelcimCheckout(token: string, plan: 'PRO' | 'TEAM', quantity: number = 1, orgName?: string) {
    const response = await fetch(`${API_BASE}/billing/helcim/init`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ plan, quantity, orgName }),
    });
    return handleResponse(response);
  },

  async verifyHelcimTransaction(token: string, transactionId: string, plan: 'PRO' | 'TEAM', quantity: number = 1, orgName?: string) {
    const response = await fetch(`${API_BASE}/billing/helcim/verify`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json' 
      },
      body: JSON.stringify({ transactionId, plan, quantity, orgName })
    });
    return handleResponse(response);
  },

  async downgradePlan(token: string) {
    const response = await fetch(`${API_BASE}/billing/downgrade`, {
      method: 'POST',
      headers: { 
        'Authorization': `Bearer ${token}`
      }
    });
    return handleResponse(response);
  }
};